import React, { useState } from "react";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import CloseIcon from "@mui/icons-material/Close";

import AutocompleteInput from "../../../Components/AutocompleteInput";
import DurationMenu from "../../../Scheduler/Calendar/Components/DurationMenu";
import { timeFormat } from "../../../tools";
import { useTranslation } from "react-i18next";
import useClasses from "../../../useClasses";

// One time slot every 30 minutes.
const timeSlots = Array.from(new Array(24 * 2)).map(
  (_, index) =>
    `${index < 20 ? "0" : ""}${Math.floor(index / 2)}:${
      index % 2 === 0 ? "00" : "30"
    }`
);

const styles = (theme) => ({
  header: {
    display: "flex",
    justifyContent: "flex-end",
    background: "rgba(0, 0, 0, 0.1)",
  },
  content: {
    padding: theme.spacing(2, 2, 0, 2),
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 2, 2, 2),
  },
  icon: {
    display: "flex",
    alignSelf: "center",
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  iconButton: {
    padding: theme.spacing(1),
  },
});

export default function DateTimeMenu({
  initTimestamp,
  handleTimestamp,
  handleClose,
}) {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const [timestamp, setTimestamp] = useState(initTimestamp);
  const momentDate = moment.utc(timestamp);
  const [time, setTime] = useState(moment.utc(timestamp).format(timeFormat));
  const handleDateChange = (value) => {
    const newTimestamp = momentDate
      .set({
        date: value.get("date"),
        month: value.get("month"),
        year: value.get("year"),
      })
      .valueOf();
    setTimestamp(newTimestamp);
  };
  const handleTimeChange = (event, value) => {
    setTime(value);
    if (event) {
      const momentTime = moment.utc(value, "HH:mm");
      const newTimestamp = momentDate
        .set({
          hour: momentTime.get("hour"),
          minute: momentTime.get("minute"),
        })
        .valueOf();
      setTimestamp(newTimestamp);
    }
  };
  const handleOk = () => {
    handleTimestamp(timestamp);
    handleClose();
  };
  return (
    <div>
      <div className={classes.header}>
        <Tooltip title={t("common.actions.close")}>
          <IconButton
            aria-label="close"
            className={classes.iconButton}
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.content}>
        <div style={{ display: "flex", paddingBottom: 16 }}>
          <div className={classes.icon}>
            <CalendarTodayOutlinedIcon fontSize="small" />
          </div>
          <DurationMenu
            startAdornment={""}
            selectedDate={momentDate}
            handleDateChange={handleDateChange}
            minDate={0}
          />
        </div>
        <div style={{ display: "flex", paddingBottom: 16 }}>
          <div className={classes.icon}>
            <ScheduleOutlinedIcon fontSize="small" />
          </div>
          <div>
            <AutocompleteInput
              width={80}
              options={timeSlots}
              value={time}
              onChange={handleTimeChange}
              variant="scheduler"
              textAlign="center"
            />
          </div>
        </div>
      </div>
      <div className={classes.footer}>
        <Button color="primary" variant="contained" onClick={handleOk}>
          {t("common.actions.ok")}
        </Button>
      </div>
    </div>
  );
}
